import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
const socialProofData = [{
  name: 'Marco T.',
  city: 'Bologna',
  time: '3 min fa'
}, {
  name: 'Claudia R.',
  city: 'Napoli',
  time: '5 min fa'
}, {
  name: 'Antonio M.',
  city: 'Milano',
  time: '7 min fa'
}, {
  name: 'Stefano B.',
  city: 'Roma',
  time: '12 min fa'
}, {
  name: 'Giovanna F.',
  city: 'Firenze',
  time: '15 min fa'
}, {
  name: 'Roberto C.',
  city: 'Torino',
  time: '18 min fa'
}, {
  name: 'Valentina S.',
  city: 'Palermo',
  time: '22 min fa'
}, {
  name: 'Davide C.',
  city: 'Genova',
  time: '25 min fa'
}, {
  name: 'Sofia L.',
  city: 'Venezia',
  time: '28 min fa'
}, {
  name: 'Andrea F.',
  city: 'Verona',
  time: '31 min fa'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const initialDelay = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(initialDelay);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    const hideTimer = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, dismissed]);
  useEffect(() => {
    if (dismissed || visible) return;
    const showTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % socialProofData.length);
      setVisible(true);
    }, 8000);
    return () => clearTimeout(showTimer);
  }, [visible, dismissed]);
  if (dismissed) return null;
  const person = socialProofData[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0 pointer-events-none'}`} data-id="element-209">
      <div className="bg-dark-800 border border-white/10 rounded-xl p-4 pr-10 shadow-2xl shadow-black/50 relative" data-id="element-210">
        <button onClick={() => setDismissed(true)} className="absolute top-3 right-3 text-gray-500 hover:text-gray-300 transition-colors" aria-label="Chiudi" data-id="element-211">
          <X className="w-4 h-4" data-id="element-212" />
        </button>

        <div className="flex items-start gap-3" data-id="element-213">
          <div className="w-10 h-10 rounded-full bg-orange-500/20 flex items-center justify-center shrink-0" data-id="element-214">
            <span className="text-orange-400 text-lg" data-id="element-215">👨‍🍳</span>
          </div>
          <div className="flex-1 min-w-0" data-id="element-216">
            <p className="text-sm text-gray-300" data-id="element-217">
              <span className="font-bold text-white" data-id="element-218">{person.name}</span>{' '}
              <span className="text-gray-500" data-id="element-219">da {person.city}</span>{' '}
              <span className="text-gray-500" data-id="element-220">🇮🇹</span>
            </p>
            <p className="text-sm text-gray-400 mt-1" data-id="element-221">
              Ha appena acquistato{' '}
              <span className="text-gold-400 font-semibold" data-id="element-222">
                Sistema Gestione Gastronomica
              </span>{' '}
              🍽️
            </p>
            <p className="text-xs text-gray-500 mt-2 flex items-center gap-1.5" data-id="element-223">
              <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block animate-pulse" data-id="element-224"></span>
              ACQUISTO VERIFICATO · {person.time}
            </p>
          </div>
        </div>
      </div>
    </div>;
}